import React, { FC } from "react";
import styles from "./footer.css";

// Deps
import { Layout } from "antd";

const { Footer: AFooter } = Layout;

export const Footer: FC = () => <AFooter className={styles.footer} />;
